import { getAccount, setAccount } from '@/api/amplify/local/persistence';
import { setAccountId } from '@/api/legacy/api';
import { updateRemoteToggles } from '@/config/features';
import { FETCH_ACCOUNT, RENAME_ACCOUNT } from '@/store/types/actions';
import { ACCOUNT_SET } from '@/store/types/mutations';
import { apolloSdk } from '../../api/apollo';

const actions = {
  async [FETCH_ACCOUNT]({ commit }, id) {
    const { node: { name, version, settings } } = await apolloSdk.Account({ accountId: id });
    commit(ACCOUNT_SET, {
      id,
      name,
      version,
      settings,
    });
  },
  async [RENAME_ACCOUNT]({ commit, state }, name) {
    const input = { name, version: state.version };
    const response = await apolloSdk.RenameAccount({ accountId: state.id, input });
    commit(ACCOUNT_SET, response.renameAccount.account);
  },
};

const mutations = {
  [ACCOUNT_SET](state, account) {
    if (account.id) {
      setAccount(account.id);
      setAccountId(account.id);
      state.id = account.id;
    }
    if (account.name) state.name = account.name;
    if (account.version) state.version = account.version;

    const { settings } = account;
    if (account.settings) {
      state.settings = settings;
      const { features } = settings;
      updateRemoteToggles(features);
    }
  },
};

export default {
  namespaced: true,
  state: { id: getAccount(), name: 'DevicePilot', version: 1 },
  actions,
  mutations,
};
